<template>
  <!--srcviewscompanycomponenttoolsvuehtmlStart-->

  <div id="defaultId1">
    <gui_tabs id="cef862" class="uJeKUqr" activeIndex="clear" @changeMenu="changeMenu">
      <gui_tab_item id="c4d1dc" class="uKD8C77 uozBR8h" active_id="menu" @input="clickMenu"
        :isDisabel="!config.menu.isActive">
        <template slot="icon">
          <!-- <svg id="cb6a9f" :class="$store.state.app.searchType == 'risk' ? 'icon' : 'icon usRlj2Q'" t="1708940141938"
            viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="31453" width="1.428em"
            height="1.0714em">
            <path id="cf6260"
              d="M1248.516339 83.308475H41.654237a41.654237 41.654237 0 0 1 0-83.308475h1206.862102a41.654237 41.654237 0 0 1 0 83.308475zM1248.516339 553.723661H41.654237a41.654237 41.654237 0 0 1 0-83.308475h1206.862102a41.654237 41.654237 0 0 1 0 83.308475zM1248.516339 1024H41.654237a41.654237 41.654237 0 0 1 0-83.308475h1206.862102a41.654237 41.654237 0 0 1 0 83.308475z"
              fill="#1A2332" p-id="4875"></path>
          </svg> -->
                <div class="tollbar-con-filter">
 
      <el-button
        round
        :class="$store.state.app.searchType == 'risk' ? 'icon usRlj2Q usRlj2QRisk' : 'icon usRlj2Q '"
        class="tollbar-con-filter-btn '"
        :disabled="!config.menu.isActive"
    

        ><i class="iconfont icon-xingzhuangjiehe"></i>Filters</el-button
      >

    </div>
        </template>
   
      </gui_tab_item>
      <!-- filter老版本 -->
      <gui_tab_item id="c2da93" v-model="activeMenuId" :isDisabel="!config.select.isActive"
        v-if="config.filter.isActive&&$store.state.app.searchType == 'risk'" class="uskVhXw" key="all" :style="{ background: $store.state.app.themeColor }"
        active_id="Clear all">
        <!-- <template slot="icon">
          <svg v-if="$store.state.app.searchType == 'company'" id="c291a7" class="icon drapdownicon uoCrWss"
            t="1716883457891" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4463"
            width="1.15em" height="1.15em">
            <path id="ca514c"
              d="M716.821 955.731c-131.96 0-238.927-106.974-238.927-238.933 0-131.96 106.967-238.933 238.927-238.933 131.96 0 238.94 106.973 238.94 238.933 0 131.96-106.98 238.933-238.94 238.933z m235.329-43.656c44.216-53.214 71.866-120.682 71.866-195.277 0-169.657-137.532-307.2-307.195-307.2-169.663 0-307.2 137.543-307.2 307.2 0 169.663 137.537 307.2 307.2 307.2 74.82 0 142.479-27.812 195.76-72.267l62.322 62.314c10.943 10.937 28.676 10.937 39.61 0 10.943-10.936 10.943-28.666 0-39.609l-62.363-62.361zM238.913 409.598c-18.855 0-34.133 15.285-34.133 34.133 0 18.856 15.278 34.134 34.133 34.134h136.526c18.85 0 34.134-15.278 34.134-34.134 0-18.848-15.285-34.133-34.134-34.133H238.913zM682.639 238.93c0-18.855-15.264-34.133-34.126-34.133h-409.6c-18.855 0-34.133 15.278-34.133 34.133 0 18.856 15.278 34.134 34.133 34.134h409.6c18.862 0 34.126-15.278 34.126-34.134zM68.233 68.265h750.947V238.93c0 18.852 15.281 34.134 34.133 34.134 18.852 0 34.134-15.282 34.134-34.134V68.265C887.447 30.56 856.87 0 819.18 0H68.233C30.529 0 0 30.561 0 68.265v887.46c0 37.704 30.529 68.273 68.233 68.273h307.227c18.85 0 34.133-15.282 34.133-34.133 0-18.852-15.282-34.134-34.133-34.134H68.233V68.265z"
              fill="#FFFFFF" p-id="4464"></path>
          </svg>
        </template> -->
        <!-- <template>


          <div id="c6a95a" class="" v-show="$store.state.app.searchType == 'company'">
            <el-dropdown id="c5e141" class="u39929">
              <div id="cc09b0" class="el-dropdown-link uOLnMLV">
                <span id="cb14a2" class="select_tab u39929 uKD8C77" style="color: #fff;">{{ $t('Toolbar.Filter') }} </span>
                <div id="ce754f" class="ua4c9f"></div>
                <div class="svg_box flex_center">
                  <svg id="cddc32" class="icon drapdownicon ujOvfa4 ujOvfa5" t="1716884069110" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4620" width="0.89em" height="0.89em">
                    <path id="c5840b" class="udVmvz8"
                      d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                      fill="#FFFFFF" p-id="4621"></path>
                  </svg>
                </div>

              </div>
              <el-dropdown-menu id="c0edfb" slot="dropdown" v-show="config.select.isActive">
                <el-dropdown-item id="c68725">
                  <div id="c61443" class="u7d9e0" @click="clickAll('Clearall')">
                    <svg id="cd177b" class="icon uhwg9v2" t="1719800485850" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="5658" width="16" height="16">
                      <path id="c57632"
                        d="M824.4 438.8c0-37.6-30-67.6-67.6-67.6l-135.2 0L621.6 104.8c0-37.6-30-67.6-67.6-67.6-37.6 0-67.6 30-67.6 67.6l0 266.4L358.8 371.2c-37.6 0-67.6 30-67.6 67.6l0 67.6L828 506.4l0-67.6L824.4 438.8 824.4 438.8zM824.4 574c-11.2 0-536.8 0-536.8 0S250 972 88.4 972L280 972c75.2 0 108.8-217.6 108.8-217.6s33.6 195.2 3.6 217.6l105.2 0c-3.6 0 0 0 11.2 0 52.4-7.6 60-247.6 60-247.6s52.4 244 45.2 244c-26.4 0-78.8 0-105.2 0l0 0 154 0c-7.6 0 0 0 11.2 0 48.8-11.2 52.4-187.6 52.4-187.6s22.4 187.6 15.2 187.6c-18.8 0-48.8 0-67.6 0l-3.6 0 90 0C895.6 972 903.2 784.4 824.4 574L824.4 574z"
                        fill="#FF6A6A" p-id="5659"></path>
                    </svg>
                    <div id="c4fd2c">{{ $t('ListofResults.ClearAll') }}</div>
                  </div>
                </el-dropdown-item>

              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </template> -->
        <div id="c6a95a" class="u79e9d" style="margin-top: -5px;" v-if="$store.state.app.searchType == 'risk'">
          <span id="cb14a2" class="select_tab " style="color: #fff !important;" @click="clickAll('ReSelectCriteria')">Reset Filters </span>
        </div>
      </gui_tab_item>

      <!-- <gui_tab_item id="c4f8cc" v-model="activeMenuId" :isDisabel="!config.filter.isActive" v-else
        class="uskVhXw u6aa68" active_id="all">
        <template slot="icon">
          <svg id="c00150" style="color: #fff;" class="icon drapdownicon uoCrWss uc38e7" t="1716883457891"
            viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4463" width="1.15em"
            height="1.15em">
            <path id="c9e811" class="uvrC2fs"
              d="M716.821 955.731c-131.96 0-238.927-106.974-238.927-238.933 0-131.96 106.967-238.933 238.927-238.933 131.96 0 238.94 106.973 238.94 238.933 0 131.96-106.98 238.933-238.94 238.933z m235.329-43.656c44.216-53.214 71.866-120.682 71.866-195.277 0-169.657-137.532-307.2-307.195-307.2-169.663 0-307.2 137.543-307.2 307.2 0 169.663 137.537 307.2 307.2 307.2 74.82 0 142.479-27.812 195.76-72.267l62.322 62.314c10.943 10.937 28.676 10.937 39.61 0 10.943-10.936 10.943-28.666 0-39.609l-62.363-62.361zM238.913 409.598c-18.855 0-34.133 15.285-34.133 34.133 0 18.856 15.278 34.134 34.133 34.134h136.526c18.85 0 34.134-15.278 34.134-34.134 0-18.848-15.285-34.133-34.134-34.133H238.913zM682.639 238.93c0-18.855-15.264-34.133-34.126-34.133h-409.6c-18.855 0-34.133 15.278-34.133 34.133 0 18.856 15.278 34.134 34.133 34.134h409.6c18.862 0 34.126-15.278 34.126-34.134zM68.233 68.265h750.947V238.93c0 18.852 15.281 34.134 34.133 34.134 18.852 0 34.134-15.282 34.134-34.134V68.265C887.447 30.56 856.87 0 819.18 0H68.233C30.529 0 0 30.561 0 68.265v887.46c0 37.704 30.529 68.273 68.233 68.273h307.227c18.85 0 34.133-15.282 34.133-34.133 0-18.852-15.282-34.134-34.133-34.134H68.233V68.265z"
              fill="#999999" p-id="4464"></path>
          </svg>
        </template>
        <template>
          <div id="cdf733" class="u79e9d">
            <div id="c01a3c" class="el-dropdown-link uOLnMLV">
              <span id="cddcdd" class="select_tab u39929 uO8qUUu u2c700 uKD8C77">{{ $t('Toolbar.Filter') }} 
              </span>
              <div id="c5ad9d" class="ua4c9f"></div>
              <svg id="c58f0f" class="icon drapdownicon ujOvfa4 uc38e7" t="1716884069110" viewBox="0 0 1024 1024"
                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4620" width="0.89em" height="0.89em">
                <path id="c649e2" class="udVmvz8"
                  d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                  fill="#FFFFFF" p-id="4621"></path>
              </svg>
            </div>
          </div>
        </template>
      </gui_tab_item> -->
      <div id="ccb548" class="u27d59"></div>
      <!-- Optimize -->
      <!-- <gui_tab_item id="cc254e" class="uKD8C77" v-if="$store.state.app.searchType == 'risk'" active_id="Optimize"
        :isDisabel="!config.Optimize.isActive" @input="clickMenu">
        <template slot="icon">
          <svg t="1732763578661" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="6066" width="16" height="16">
            <path
              d="M663.857292 663.526559c-50.786584 50.824745-101.738534 95.047553-151.316671 132.814708-51.696099-39.395379-102.539925-83.95528-151.361192-132.814708-49.336447-49.387329-94.017193-100.536447-132.827429-151.424795 38.962882-51.174559 83.624547-102.272795 132.827429-151.526559 49.13928-49.177441 100.123031-93.826385 151.189465-132.782907 51.072795 38.880199 102.342758 83.599106 151.488398 132.782907 50.818385 50.869267 95.022112 101.89754 132.770186 151.54564-38.975602 51.219081-83.592745 102.171031-132.770186 151.405714m-572.575006 270.145193c-36.011727-36.043528-31.012571-115.45759 13.712695-217.857591 21.077863-48.287006 49.781665-98.933665 84.680348-150.127304 37.748075 48.312447 80.228174 96.434087 126.568944 142.819379 46.041839 46.08 93.877267 88.502857 142.59041 126.664348-170.282932 116.042733-315.970783 150.133665-367.552397 98.501168m887.000248-243.336746c-25.059379-57.382161-60.034385-117.664596-102.819776-178.214161 28.296745-40.050484 53.216199-80.12641 74.268621-119.604472a31.826683 31.826683 0 0 0-13.070311-43.039802 31.763081 31.763081 0 0 0-43.001639 13.083031c-16.841938 31.578634-36.35518 63.615205-58.221715 95.73446-37.856199-48.356969-80.368099-96.376845-126.645267-142.692174-46.474335-46.518857-94.513292-89.024398-142.641292-126.708869 51.136398-34.917764 101.725814-63.640646 149.949218-84.73759 102.323677-44.769789 181.655056-49.762584 217.660422-13.712696 14.520447 14.526807 22.432596 36.253416 23.520199 64.562882 0.667826 17.554286 15.449043 31.279702 32.965167 30.560994a31.782161 31.782161 0 0 0 30.535553-32.996969c-1.710907-44.852472-15.87518-80.88328-42.092124-107.106584-56.31364-56.377242-158.618236-56.224596-288.042932 0.407056-57.375801 25.09754-117.664596 60.142509-178.201441 103.016944C384.629665 58.450683 260.013317 4.553938 166.295056 3.186484h-0.477019a31.788522 31.788522 0 0 0-31.76308 31.336945 31.794882 31.794882 0 0 0 31.305142 32.26554c76.844522 1.119404 182.653615 46.626981 293.258336 122.212174-48.248845 37.843478-96.166957 80.349019-142.374162 126.600745-46.308969 46.34713-88.846311 94.398807-126.71523 142.793938C124.037565 362.597764 81.379379 270.336 70.299826 195.564919a31.820323 31.820323 0 0 0-36.10077-26.802087 31.801242 31.801242 0 0 0-26.776646 36.132572C20.49272 293.016646 71.68 401.509764 149.688447 511.968199 106.845814 572.549565 71.832646 632.908323 46.760547 690.328646c-56.58077 129.558261-56.720696 231.958261-0.413417 288.310062 28.080497 28.118658 67.603081 42.168447 116.233541 42.168447 48.865789 0 106.934857-14.202435 171.809391-42.588223 120.183255-52.567453 253.144248-148.365516 374.402385-269.725416 46.308969-46.353491 88.763627-94.271602 126.613466-142.641292 115.902807 170.403776 149.930137 316.180671 98.354882 367.813167-36.227975 36.234335-116.068174 31.018932-219.123279-14.367801a31.782161 31.782161 0 0 0-41.888597 16.301317 31.833043 31.833043 0 0 0 16.294957 41.926758c65.54872 28.856447 124.15205 43.294211 173.424894 43.287851 48.605019 0 88.133963-14.056149 116.22082-42.168448 56.31364-56.364522 56.167354-158.751801-0.407056-288.310062M514.792149 384.356174c70.102658 0 127.115925 57.07687 127.115926 127.23041 0 70.15354-57.019627 127.217689-127.115926 127.217689-70.089938 0-127.096845-57.064149-127.096845-127.217689s57.006907-127.23041 127.096845-127.23041z m0 190.832894c35.044969 0 63.564323-28.532075 63.564323-63.602484 0-35.08313-28.519354-63.621565-63.564323-63.621565s-63.545242 28.538435-63.545242 63.615205c0 35.08313 28.506634 63.608845 63.551602 63.608844zM44.489938 120.374062a41.328894 41.328894 0 0 1-41.309814-41.341615 41.328894 41.328894 0 0 1 41.309814-41.347975 41.328894 41.328894 0 0 1 41.309814 41.341615 41.328894 41.328894 0 0 1-41.309814 41.354335zM924.729242 276.22559a41.328894 41.328894 0 0 1 41.309814-41.347975 41.328894 41.328894 0 0 1 41.309814 41.341615 41.328894 41.328894 0 0 1-41.309814 41.354335 41.322534 41.322534 0 0 1-41.309814-41.347975z m-320.957217 582.045416a41.328894 41.328894 0 0 1 41.309814 41.347975 41.322534 41.322534 0 0 1-41.309814 41.347976 41.328894 41.328894 0 0 1-41.309814-41.341615 41.328894 41.328894 0 0 1 41.309814-41.354336z"
              fill="#1A2332" p-id="6067"></path>
          </svg>
        </template>
        <div id="c80af0" class="uUgrpts uKD8C77" myData="测试">Optimize</div>
      </gui_tab_item> -->
      <gui_tab_item id="cc254e" class="uKD8C77" active_id="select" :isDisabel="!config.select.isActive"
        @input="clickMenu">
        <template slot="icon">
          <svg id="c6f7d3" class="icon uupMxrD" t="1710138718004" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="6769" width="20" height="20">
            <path id="c04c3a"
              d="M913.92 1016.32H354.56a31.36 31.36 0 0 1 0-64h559.36a31.36 31.36 0 0 0 31.36-31.36V569.6a31.36 31.36 0 0 1 64 0v352.64a94.08 94.08 0 0 1-95.36 94.08z"
              fill="#8497AB" p-id="6770"></path>
            <path id="cf665a"
              d="M761.6 844.8H113.28A94.08 94.08 0 0 1 19.2 750.72V103.04A94.08 94.08 0 0 1 113.28 8.96h547.84a31.36 31.36 0 1 1 0 64H113.28a31.36 31.36 0 0 0-31.36 31.36v646.4a31.36 31.36 0 0 0 31.36 31.36H761.6a31.36 31.36 0 0 0 30.72-31.36V569.6a32 32 0 0 1 64 0v181.12a94.08 94.08 0 0 1-94.72 94.08z"
              fill="#8497AB" p-id="6771"></path>
            <path id="c375dd" v-show="isOpenSlct"
              d="M913.92 1016.32H301.44a31.36 31.36 0 0 1 0-64h612.48a31.36 31.36 0 0 0 31.36-31.36V569.6a31.36 31.36 0 0 1 64 0v352.64a94.08 94.08 0 0 1-95.36 94.08zM482.56 581.76a30.72 30.72 0 0 1-22.4-10.24L245.12 344.32a31.36 31.36 0 0 1 0-44.16 30.72 30.72 0 0 1 44.16 0l192 203.52L960 29.44a31.36 31.36 0 0 1 44.16 0 30.08 30.08 0 0 1 0 44.16L504.32 572.16a28.8 28.8 0 0 1-21.76 9.6z"
              fill="#8497AB" p-id="6772"></path>
          </svg>
          <svg id="c76093" class="icon" t="1716885366259" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="4781" width="1.428rem" height="1.428rem">
            <path id="c5c104"
              d="M218.47269380045435 793.6915279012346c-9.468623156464195 9.468623156464195-9.468623156464195 23.67155659662222 0 33.14017975308642 82.85044938271605 78.11613780448396 189.37245536205432 123.09209585588148 302.9959293560098 123.09209585588148 241.4498814280691 0 437.92380351020245-196.47392337667162 437.92380351020245-437.92380351020245S762.9185032899951 74.07619648979755 521.4686231564642 74.07619648979755 83.54481835172345 270.55011857193097 83.54481835172345 512c0 82.85044938271605 23.67155659662222 165.7008987654321 68.647515942558 236.71556984983704 7.101466720079011 11.83577829831111 21.304401454775306 14.202934734696296 33.14017975308642 7.101466720079011 11.83577829831111-7.101466720079011 14.202934734696296-21.304401454775306 7.101466720079011-33.14017975308642-40.24164647316543-61.54604792794074-61.54604792794074-134.92787415419258-61.54604792794074-210.6768568168296 0-215.41116839506174 175.16952192189632-390.580690316958 390.580690316958-390.580690316958S912.0493121788841 296.58883160493826 912.0493121788841 512s-175.16952192189632 390.580690316958-390.58068902241973 390.580690316958c-101.78769440110615 0-196.47392337667162-37.87449133131852-269.8557496029234-108.88916241572346-9.468623156464195-9.468623156464195-26.038713033007408-9.468623156464195-33.14017975308642 0z"
              fill p-id="4782"></path>
            <path id="c67e50"
              d="M481.22697538876054 677.700898765432c7.101466720079011 0 11.83577829831111-2.3671551418469137 16.57008987654321-7.101466720079011l248.55134814814815-248.55134814814815c9.468623156464195-9.468623156464195 9.468623156464195-23.67155659662222 0-33.14017975308642s-23.67155659662222-9.468623156464195-33.14017975308642 0l-231.98125827160493 231.98125827160493-153.8651191725827-153.865120467121c-9.468623156464195-9.468623156464195-23.67155659662222-9.468623156464195-33.14017975308642 0s-9.468623156464195 23.67155659662222 0 33.14017975308642l170.43520904912594 170.43521034366415c4.734311578232098 4.734311578232098 11.83577829831111 7.101466720079011 16.57008987654321 7.101466720079011z"
              fill p-id="4783"></path>
          </svg>
        </template>

        <div id="c80af0" class="uUgrpts" myData="测试">{{ $t('Toolbar.Select') }}</div>
      </gui_tab_item>
      <gui_tab_item id="c0880e" v-model="activeMenuId" active_id="edit" :isDisabel="!config.edit.isActive">
        <template slot="icon">
          <svg id="cefb95" class="icon" t="1719556245485" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="4955" width="1.82rem" height="1.82rem">
            <path id="c311ab"
              d="M769.824 291.542L666.519 188.237c-15.802-15.802-41.421-15.799-57.224 0l-361.94 361.94c-12.357 12.358-11.885 12.825-11.889 39.389-0.005 132.545 0.064 132.965 0.064 132.965s0.42 0.07 132.969 0.065c26.561 0 27.027 0.468 39.39-11.891L769.824 348.77c15.805-15.802 15.809-41.421 0-57.228zM394.826 664.313c-14.95 14.949-15.478 14.416-45.967 14.416-69.291 0-69.404-0.117-69.404-0.117s-0.121-0.114-0.121-69.409c0-30.489-0.529-31.017 14.416-45.963l240.425-240.425 101.071 101.076-240.42 240.422z m270.149-270.151L563.903 293.086l46.567-46.566c27.437-27.437 27.852-27.023 54.879 0.006l46.187 46.187c27.033 27.026 27.447 27.442 0.007 54.885l-46.568 46.564zM811.435 718.375H637.664c-11.609 0-21.02-9.411-21.02-21.021 0-11.611 9.41-21.021 21.02-21.021h173.771c11.612 0 21.021 9.41 21.021 21.021 0 11.61-9.409 21.021-21.021 21.021zM811.435 847.612H256.487c-11.612 0-21.021-9.411-21.021-21.021 0-11.609 9.408-21.021 21.021-21.021h554.947c11.612 0 21.021 9.411 21.021 21.021 0.001 11.61-9.408 21.021-21.02 21.021z"
              fill="#8497AB" p-id="4956"></path>
          </svg>
        </template>

        <template>
          <el-dropdown id=" c9cc9e" class=" u994i9a" placement="bottom" trigger="click"    :disabled="!config?.edit?.isActive">
            <div id="c4a158" class="el-dropdown-link uOLnMLV">
              <span id="c996c2" class="select_tab u39929 uKD8C77">{{ $t('Toolbar.Edit') }}  </span>
              <svg id="cbde7e" class="icon" t="1716884069110" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4620" width="0.6em" height="0.6em">
                <path id="cce1f9"
                  d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                  fill="#333333" p-id="4621"></path>
              </svg>
            </div>
            <div  v-show="config.edit.isActive">
            <el-dropdown-menu id="c3b672" slot="dropdown">

              <el-cascader-panel id="c255ed" v-model="cascader6Value" :options="Editoptions" ref="cascader"
                :filterable="true" :props="{ multiple: true, value: 'columnName', label: 'screenName', emitPath: false }"
                @change="changeColumn">
                <template #default="{ node, data }">
                  <span id="c2e092">
                    <span id="caa1e7">{{ data.screenName }}
                    </span>
                  </span>
                  <span id="c5f4d9" v-if="!node.isLeaf">
                    <span id="ceb4bf">({{ data.children.length }})
                    </span>
                  </span>
                </template>
              </el-cascader-panel>
            </el-dropdown-menu>
          </div>
          </el-dropdown>
        </template>
      </gui_tab_item>
      <!-- sort -->
      <div style="display: flex;" v-for="(item, index) in queryList" @click="powermethod(item)" :key="index">
        <div style="display: flex;" v-if="item.screenName ==  $t('Toolbar.Sortby') && item.isShow == true">
          <gui_tab_item id="c2afd01" v-model="activeMenuId" class="uKD8C77 " active_id="sort"
            :isDisabel="!config.sort.isActive || !item.hasPrivilege">
            <template slot="icon">
              <svg id="ca4740" class="icon uBOJajX" t="1709802263094" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="11088" width="1.28rem" height="1.28rem">
                <path id="c042e4" class="uQnNgeB"
                  d="M741.248 79.68l-234.112 350.08v551.488l55.296 24.704v-555.776l249.152-372.544c8.064-32.96-10.496-59.712-41.152-59.712h-709.248c-30.464 0-49.28 26.752-41.344 59.712l265.728 372.544v432.256l55.36 24.704v-478.592l-248.896-348.864h649.216z m-68.032 339.648c0-16.832 12.096-30.592 27.264-30.848h277.888c15.232 0 27.712 13.824 27.712 30.848s-12.416 30.848-27.712 30.848h-277.888c-15.168-0.32-27.264-14.016-27.264-30.848z m0 185.216c0-16.832 12.096-30.592 27.264-30.848h277.888c15.232 0 27.712 13.824 27.712 30.848s-12.416 30.848-27.712 30.848h-277.888c-15.168-0.256-27.264-14.016-27.264-30.848z m0 185.28c0-16.832 12.096-30.592 27.264-30.848h277.888c15.232 0 27.712 13.824 27.712 30.848s-12.416 30.848-27.712 30.848h-277.888c-15.168-0.32-27.264-13.952-27.264-30.848z"
                  p-id="11089" fill="#8497AB"></path>
              </svg>
            </template>
            <template>
              <el-dropdown id="c4611e" class="u994i9a udS8Wxg" trigger="click" placement="bottom"
                :disabled="!config.sort.isActive">
                <div v-if="item.hasPrivilege" id="cb5823" class="el-dropdown-link u324ce">
                  <span id="c3ca07" class="uUgrpts select_tab unrH9VJ uKD8C77" myData="测试">
                   {{ $t('Toolbar.Sortby') }}
                  </span>
                  <svg id="c434a0" class="icon uLpo7l5" t="1716884069110" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="4620" width="0.5em" height="0.5em">
                    <path id="c64e09" class="uFkWpsb"
                      d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                      fill="#333333" p-id="4621"></path>
                  </svg>
                </div>
                <el-popover v-else placement="top-start" width="200" trigger="hover">
                  <div slot="reference" id="c15095" class="uUgrpts" myData="测试"> {{ $t('Toolbar.Sortby') }} <svg id="c8fd0c" class="icon"
                      t="1716884069110" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                      p-id="4620" width="0.5em" height="0.5em">
                      <path id="ca66e6"
                        d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                        fill="#333333" p-id="4621"></path>
                    </svg></div>
                </el-popover>
                <div id="c106a6" v-show="item.hasPrivilege" class="u2ed25 u5c5c7">
                  <el-dropdown-menu id="c062ee" class="ujAIBvN" slot="dropdown"
                    v-show="$route.meta.title != 'companyDetails'">
                    <el-cascader-panel id="cef5b0" v-model="sortList" class="u7PkfAW" :options="sort_listOptions"
                      @change="CheckSort" ref="cascader" :filterable="true" :props="{ multiple: false }">
                      <template #default="{ node, data }">
                        <span id="c214bd" class="uwfvWhL">
                          <span id="ce9d28" class="uvHkMZZ" v-if="data.label==$t('Toolbar.ascending') || data.label==$t('Toolbar.descending')">{{ data.label }} </span>
                            <span id="ce9d28" class="uvHkMZZ" v-else>{{ data.label}} </span>
                        </span>
                        <span id="cbe032" class="uAGF3UD" v-if="!node.isLeaf">
                          <span id="cf3b86" class="utCGg7o">({{ data.children.length }})
                          </span>
                        </span>
                      </template>
                    </el-cascader-panel>
                  </el-dropdown-menu>
                </div>
              </el-dropdown>
            </template>
          </gui_tab_item>
        </div>
        <!-- Collect -->
        <div style="display: flex;" v-if="item.screenName == $t('Toolbar.Collect') && item.isShow == true">
          <gui_tab_item id="c0b472" v-model="activeMenuId" active_id="collect"
            :isDisabel="!config.collect.isActive || !item.hasPrivilege">
            <template slot="icon">
              <svg id="c19316" class="icon" t="1710468716429" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5489" width="1.42rem" height="1.42rem">
                <path id="c28a86"
                  d="M295.6 935.9c-18.8 0-37.4-5.9-53.4-17.5-28.2-20.5-42-54.6-36.1-88.9l29.6-172.6c2.3-13.3-2.1-26.8-11.7-36.1l-0.1-0.1L98.5 498.4c-24.9-24.3-33.7-60-23-93.1 10.8-33.2 38.9-56.9 73.3-61.9l173.3-25.1c13.3-1.9 24.8-10.3 30.8-22.4l77.5-157c15.4-31.3 46.7-50.7 81.5-50.7s66.1 19.4 81.5 50.7l77.5 157c5.9 12 17.4 20.4 30.8 22.4L875 343.5c34.5 5 62.6 28.8 73.4 61.9 10.8 33.1 1.9 68.8-23 93.1L800 620.7c-9.6 9.4-14 22.9-11.8 36.2l29.6 172.5c5.9 34.4-8 68.4-36.2 88.9-28.2 20.5-64.8 23.1-95.6 6.9l-155-81.5c-11.9-6.3-26.1-6.3-38 0l-155 81.5c-13.5 7.2-28 10.7-42.4 10.7z m-36.9-351c21.5 20.9 31.3 50.9 26.2 80.5L255.3 838c-2.7 15.7 3.4 30.7 16.2 40 12.9 9.4 29 10.5 43.1 3.1l155-81.5a91.03 91.03 0 0 1 84.6 0l155 81.5c14.1 7.4 30.1 6.2 43-3.1 12.9-9.4 19-24.3 16.3-40L739 665.3c-5-29.5 4.8-59.6 26.2-80.4l125.4-122.2c11.4-11.1 15.3-26.8 10.4-41.9-4.9-15.1-17.3-25.5-33-27.8l-173.3-25.2h-0.1c-29.6-4.4-55.2-23-68.3-49.8l-77.5-157c-7.1-14.3-20.8-22.8-36.7-22.8-15.9 0-29.6 8.5-36.7 22.8l-77.5 157a90.69 90.69 0 0 1-68.4 49.8l-173.3 25.1c-15.7 2.3-28.1 12.7-33 27.9-4.9 15.1-1 30.8 10.3 41.9l125.2 122.2z"
                  fill="#333333" p-id="4865"></path>
              </svg>
            </template>
            <template>
              <el-dropdown id="cc6c02" class="u994i9a" trigger="click" placement="bottom"
                :disabled="!config?.collect?.isActive||!item.hasPrivilege">

                <!--&& -->
                <div v-if="item.hasPrivilege" id="cacb01" class="el-dropdown-link u324ce">
                  <div id="c42102" class="uUgrpts select_tab unrH9VJ uKD8C77" myData="测试">
                    {{ $t('Toolbar.Collect') }}
                  </div>
                  <svg id="c04b74" class="icon" t="1716884069110" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="4620" width="0.5em" height="0.5em">
                    <path id="cd54b1"
                      d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                      fill="#333333" p-id="4621"></path>
                  </svg>
                </div>
                <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
                  <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试"> {{ $t('Toolbar.Collect') }} <svg id="c8fd0c"
                      class="icon" t="1716884069110" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="4620" width="0.5em" height="0.5em">
                      <path id="ca66e6"
                        d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                        fill="#333333" p-id="4621"></path>
                    </svg></div>
                </el-popover>
                <div>
                  <div id="c2e9fd" v-show="item.hasPrivilege" slot="dropdown">
                    <el-dropdown-menu id="c7c233" class="uWDPJiJ">
                      <div v-show="favoritesList.length > 0">
                        <el-checkbox-group v-model="checkList" @change="CollectCheckBook">
                          <el-checkbox class="elcheckbook u7fb7a u7fb7a10" v-for="(ite, inde) in favoritesList"
                            :key="inde" :label="ite.id">{{ ite.name }}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                      <div class="CollecInput" v-if="CollectShow">
                        <el-input autocomplete="off" placeholder="Favorite Name" v-model="CollectAdd">
                          <el-button slot="append" @click="AddCollect">Confirm</el-button>
                        </el-input>
                      </div>
                      <div class="CollectBottom uKD8C77" @click="CollectShow = true">
                        <svg t="1725592052707" class="icon" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="6507" width="20" height="20">
                          <path
                            d="M512 51.2c253.952 0 460.8 206.848 460.8 460.8s-206.848 460.8-460.8 460.8-460.8-206.848-460.8-460.8 206.848-460.8 460.8-460.8m0-51.2C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512S794.624 0 512 0z"
                            fill="#1A2332" p-id="6508"></path>
                          <path
                            d="M244.736 540.672H773.12c14.336 0 25.6-11.264 25.6-25.6s-11.264-25.6-25.6-25.6H244.736c-14.336 0-25.6 11.264-25.6 25.6s11.776 25.6 25.6 25.6z"
                            fill="#1A2332" p-id="6509"></path>
                          <path
                            d="M510.976 224.256c-14.336 0-25.6 11.264-25.6 25.6V778.24c0 14.336 11.264 25.6 25.6 25.6s25.6-11.264 25.6-25.6V249.856c0.512-14.336-10.752-25.6-25.6-25.6z"
                            fill="#1A2332" p-id="6510"></path>
                        </svg>
                        <span style="margin-left: 10px">{{ $t('Toolbar.Customfolder') }}</span>
                      </div>

                    </el-dropdown-menu>
                  </div>
                </div>


              </el-dropdown>
            </template>
          </gui_tab_item>
        </div>

        <!-- Saved -->

        <div style="display: flex;" v-show="item.screenName == $t('Toolbar.Saved') && item.isShow == true">
          <gui_tab_item id="c0b472"  class="uKD8C77"  v-model="activeMenuId" active_id="saved" 
            :isDisabel="!config.saved.isActive || !item.hasPrivilege">
            <template slot="icon">
              <svg id="c6e625" class="icon" t="1717121622150" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4670" width="1.24rem" height="1.24rem">
                <path id="c0ceb3"
                  d="M768 102.4v307.2c0 34.816-26.624 61.44-61.44 61.44h-389.12c-34.816 0-61.44-26.624-61.44-61.44v-307.2h-92.16c-34.816 0-61.44 26.624-61.44 61.44V870.4c0 34.816 26.624 61.44 61.44 61.44h706.56c34.816 0 61.44-26.624 61.44-61.44v-104.448c0-12.288 8.192-20.48 20.48-20.48s20.48 8.192 20.48 20.48v104.448c0 57.344-45.056 102.4-102.4 102.4H163.84c-57.344 0-102.4-45.056-102.4-102.4v-706.56c0-57.344 45.056-102.4 102.4-102.4h706.56c57.344 0 102.4 45.056 102.4 102.4v417.792c0 12.288-8.192 20.48-20.48 20.48s-20.48-8.192-20.48-20.48v-417.792c0-34.816-26.624-61.44-61.44-61.44h-102.4z m-471.04 0v307.2c0 10.24 8.192 20.48 20.48 20.48h389.12c10.24 0 20.48-8.192 20.48-20.48v-307.2h-430.08z m301.056 92.16c0-12.288 8.192-20.48 20.48-20.48s20.48 8.192 20.48 20.48v122.88c0 12.288-8.192 20.48-20.48 20.48s-20.48-8.192-20.48-20.48v-122.88z"
                  fill="#32373B" p-id="4671"></path>
              </svg>
            </template>
            <template>
            
              <el-dropdown id="cac680" class="u994i9a udS8Wxg" trigger="click" placement="bottom" :disabled="!config?.saved?.isActive||!item.hasPrivilege">
                <div id="c68926" v-if="item.hasPrivilege" class="el-dropdown-link u324ce">
                  <div id="c31216" class="uUgrpts select_tab unrH9VJ uKD8C77" myData="测试">
                  {{ $t('Toolbar.Saved') }}
                  </div>
                  <svg id="c8fd0c" class="icon" t="1716884069110" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="4620" width="0.5rem" height="0.5rem">
                    <path id="ca66e6"
                      d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                      fill="#333333" p-id="4621"></path>
                  </svg>

                </div>
                <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
                  <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试"> {{  $t('Toolbar.Saved')}} <svg id="c8fd0c"
                      class="icon" t="1716884069110" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="4620" width="0.5em" height="0.5em">
                      <path id="ca66e6"
                        d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                        fill="#333333" p-id="4621"></path>
                    </svg></div>
                </el-popover>
                <div id="c65b56" v-show="item.hasPrivilege" slot="dropdown">
                  <div v-show="favoritesList.length > 0">
                    <el-dropdown-menu id="c30e13" class="uWDPJiJ" >
                      <el-dropdown-item id="c5c5cb" v-for="(item, index) in favoritesList" :key="index">
                        <div @click="ChangeSave(item.id)">
                          <div id="cf870f" @click="activeSavedId = item.id" class="u606de">

                            <div id="cd7742" :class="activeSavedId == item.id ? 'active' : ''" class="ucc8d2 uKD8C77">
                              {{ item.name }}
                            </div>
                          </div>
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </div>
                </div>
              </el-dropdown>
            </template>
          </gui_tab_item>
        </div>
        <!-- Compare -->

        <div style="display: flex;" v-if="item.screenName == $t('Toolbar.Compare') && item.isShow == true">
          <gui_tab_item id="c11a66" v-model="activeMenuId" class="uKD8C77" active_id="Compare"
            :isDisabel="!config.compare.isActive || !item.hasPrivilege" @input="clickMenu">
            <template slot="icon">
              <svg id="ca981b" class="icon" t="1717121717312" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4831" width="1.2428rem" height="1.2428rem">
                <path id="c9a351"
                  d="M615.68 102.4c6.4 0 12.8-2.56 17.92-7.68L665.6 62.72c10.24-10.24 10.24-25.6 0-35.84-10.24-10.24-25.6-10.24-35.84 0l-32 32c-10.24 10.24-10.24 25.6 0 35.84 5.12 5.12 11.52 7.68 17.92 7.68zM615.68 243.2c6.4 0 12.8-2.56 17.92-7.68L765.44 103.68c10.24-10.24 10.24-25.6 0-35.84-10.24-10.24-25.6-10.24-35.84 0L597.76 199.68c-10.24 10.24-10.24 25.6 0 35.84 5.12 5.12 11.52 7.68 17.92 7.68zM615.68 384c6.4 0 12.8-2.56 17.92-7.68l215.04-215.04c10.24-10.24 10.24-25.6 0-35.84-10.24-10.24-25.6-10.24-35.84 0L597.76 340.48c-10.24 10.24-10.24 25.6 0 35.84 5.12 5.12 11.52 7.68 17.92 7.68zM615.68 524.8c6.4 0 12.8-2.56 17.92-7.68l282.88-282.88c10.24-10.24 10.24-25.6 0-35.84-10.24-10.24-25.6-10.24-35.84 0L597.76 481.28c-10.24 10.24-10.24 25.6 0 35.84 5.12 5.12 11.52 7.68 17.92 7.68zM615.68 665.6c6.4 0 12.8-2.56 17.92-7.68l336.64-336.64c10.24-10.24 10.24-25.6 0-35.84-10.24-10.24-25.6-10.24-35.84 0L597.76 622.08c-10.24 10.24-10.24 25.6 0 35.84 5.12 5.12 11.52 7.68 17.92 7.68zM615.68 806.4c6.4 0 12.8-2.56 17.92-7.68l372.48-372.48c10.24-10.24 10.24-25.6 0-35.84-10.24-10.24-25.6-10.24-35.84 0L597.76 762.88c-10.24 10.24-10.24 25.6 0 35.84 5.12 5.12 11.52 7.68 17.92 7.68zM1016.32 520.96c-10.24-10.24-25.6-10.24-35.84 0L597.76 903.68c-10.24 10.24-10.24 25.6 0 35.84 5.12 5.12 11.52 7.68 17.92 7.68s12.8-2.56 17.92-7.68l382.72-382.72c10.24-10.24 10.24-25.6 0-35.84zM929.28 711.68l-216.32 217.6c-10.24 10.24-10.24 25.6 0 35.84 5.12 5.12 11.52 7.68 17.92 7.68 6.4 0 12.8-2.56 17.92-7.68l216.32-217.6c10.24-10.24 10.24-25.6 0-35.84-10.24-10.24-25.6-10.24-35.84 0zM512 0C229.12 0 0 229.12 0 512s229.12 512 512 512c14.08 0 25.6-11.52 25.6-25.6V25.6c0-14.08-11.52-25.6-25.6-25.6z m-25.6 971.52C244.48 958.72 51.2 757.76 51.2 512S244.48 65.28 486.4 52.48v919.04z"
                  fill="#333333" p-id="4832"></path>
              </svg>
            </template>
            <template>
              <div id="c22c95" v-if="item.hasPrivilege" class="uUgrpts uKD8C77" myData="测试">{{ item.screenName }}</div>
              <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
                <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试">{{ item.screenName }}</div>
              </el-popover>
            </template>
          </gui_tab_item>
        </div>

        <!-- Export -->

        <div style="display: flex;" v-if="item.screenName == $t('Toolbar.Export') && item.isShow == true">
          <gui_tab_item id="cabc6b" v-model="activeMenuId" active_id="Export"
            :isDisabel="!config.export.isActive || !item.hasPrivilege" @input="clickMenu">
            <template slot="icon">
              <svg id="c392e2" class="icon" t="1717121819586" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4992" width="1.24rem" height="1.24rem">
                <path id="cbfb3f"
                  d="M686.08 989.866667H165.546667c-51.2 0-92.16-40.96-92.16-92.16V126.293333c0-51.2 40.96-92.16 92.16-92.16h573.44c6.826667 0 11.946667 1.706667 17.066666 6.826667l187.733334 174.08c5.12 5.12 8.533333 11.946667 8.533333 18.773333v256c0 13.653333-11.946667 25.6-25.6 25.6s-25.6-11.946667-25.6-25.6V244.053333L728.746667 85.333333h-563.2C141.653333 85.333333 122.88 104.106667 122.88 126.293333v769.706667c0 22.186667 18.773333 40.96 40.96 40.96h520.533333c13.653333 0 25.6 11.946667 25.6 25.6S699.733333 989.866667 686.08 989.866667z"
                  fill="#333333" p-id="4993"></path>
                <path id="cb403e"
                  d="M919.893333 259.413333h-121.173333c-51.2 0-92.16-40.96-92.16-92.16V59.733333c0-13.653333 11.946667-25.6 25.6-25.6s25.6 11.946667 25.6 25.6v105.813334c0 22.186667 18.773333 40.96 40.96 40.96h121.173333c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 27.306667-25.6 27.306666zM500.053333 305.493333H208.213333c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h291.84c13.653333 0 25.6 11.946667 25.6 25.6 0 15.36-11.946667 25.6-25.6 25.6zM616.106667 575.146667H208.213333c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h407.893334c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6zM380.586667 440.32H208.213333c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h172.373334c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6z"
                  fill="#333333" p-id="4994"></path>
                <path id="c319c0"
                  d="M914.773333 779.946667H600.746667c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h314.026666c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6z"
                  fill="#333333" p-id="4995"></path>
                <path id="c6af97"
                  d="M831.146667 873.813333c-6.826667 0-13.653333-1.706667-18.773334-6.826666-10.24-10.24-10.24-25.6 0-35.84l75.093334-75.093334-75.093334-75.093333c-10.24-10.24-10.24-25.6 0-35.84 10.24-10.24 25.6-10.24 35.84 0l93.866667 93.866667c5.12 5.12 6.826667 11.946667 6.826667 18.773333s-3.413333 13.653333-6.826667 18.773333L848.213333 870.4c-5.12 1.706667-11.946667 3.413333-17.066666 3.413333z"
                  fill="#333333" p-id="4996"></path>
              </svg>
            </template>
            <div>

            </div>

            <download-excel v-if="item.hasPrivilege && config.export.isActive" id="c0b0a6" :data="DetailsForm"
              :fields="json_fields" name="Company.xls">

              <div class="uKD8C77" @click="exportCompany">{{ $t('Toolbar.Export') }}</div>

            </download-excel>
            <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
              <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试">{{ $t('Toolbar.Export') }}</div>
            </el-popover>
          </gui_tab_item>
        </div>
        <!-- Download -->

        <div style="display: flex;" v-if="item.screenName == $t('Toolbar.Download') && item.isShow == true">
          <gui_tab_item id="c9c0e4" v-model="activeMenuId" active_id="download"
            :isDisabel="!item.hasPrivilege || !config.download.isActive" @input="clickMenu">
            <template slot="icon">
              <svg id="c1f02f" class="icon" t="1717122025138" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5156" width="1.3428em" height="1.3428em">
                <path id="cf91f2"
                  d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                  fill="#32373B" p-id="5157"></path>
              </svg>
            </template>
            <template>

              <div id="c15095" v-if="item.hasPrivilege" class="uUgrpts uKD8C77" myData="测试">

              <el-popover v-if="DownloadStatus ==2" placement="top-start" :disabled="true" width="200" trigger="hover">
                <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试">In production</div>
              </el-popover>
              <div v-else slot="reference" id="c15095" class="uUgrpts" >{{ $t('Toolbar.Download') }}</div>
            
                <!-- <el-popover popper-class="tool_popover" v-else placement="top-start" width="200" trigger="hover"
                  :disabled="$route.meta.title != 'companyDetails'"
                  :content="DownloadStatus == '3' ? 'The offline report you downloaded is currently being produced.' : 'The offline report you downloaded has been completed. Please download it from the updates ordered screen in your personal center'">
                  <div slot="reference" id="c15095" class="uUgrpts" myData="测试">{{ DownloadStatus == '2' ? 'In production'
                    : 'Download' }}</div>
                </el-popover> -->
            
                </div>
            </template>
          </gui_tab_item>
        </div>
        <!-- Update -->

        <div style="display: flex;" v-if="item.screenName == $t('Toolbar.Update') && item.isShow == true">
          <gui_tab_item id="c40519" v-model="activeMenuId" class="uKD8C77 svg_update" active_id="Update"
            :isDisabel="!config.update.isActive || !item.hasPrivilege" @input="clickMenu">
            <template slot="icon">
              <svg id="c127ec" class="icon" t="1710468911970" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="7611" width="1.28rem" height="1.28rem">
                <path id="c0cc7b"
                  d="M960 416V192l-73.056 73.056a447.712 447.712 0 0 0-373.6-201.088C265.92 63.968 65.312 264.544 65.312 512S265.92 960.032 513.344 960.032a448.064 448.064 0 0 0 415.232-279.488 38.368 38.368 0 1 0-71.136-28.896 371.36 371.36 0 0 1-344.096 231.584C308.32 883.232 142.112 717.024 142.112 512S308.32 140.768 513.344 140.768c132.448 0 251.936 70.08 318.016 179.84L736 416h224z"
                  p-id="7612"></path>
              </svg>
            </template>
            <!-- <div id="c15095" class="uUgrpts" myData="测试">Update</div> -->
            <!-- && UpdateStatus==2 || UpdateStatus==6 -->
            <template>


              <div id="c15095" v-if="$route.meta.title != 'companyDetails'" class="uUgrpts uKD8C77" myData="测试">{{ $t('Toolbar.Update') }}
              </div>
              <div v-else>
                <div v-if="UpdateStatus == 2 || UpdateStatus == 6" slot="reference" id="c15095" class="uUgrpts" myData="测试">
                  {{$t('Toolbar.Update')}}</div>
                <el-popover popper-class="tool_popover" v-else placement="top-start" width="200" trigger="hover"
                  :disabled="$route.meta.title != 'companyDetails'"
                  :content="UpdateStatus == '3' ? 'The offline report you downloaded is currently being produced.' : 'The offline report you downloaded has been completed. Please download it from the updates ordered screen in your personal center'">
                  <div slot="reference" id="c15095" class="uUgrpts" myData="测试">{{ UpdateStatus == '3' ? 'In production'
                    : 'Finished' }}</div>
                </el-popover>
              </div>
            </template>
          </gui_tab_item>
        </div>
        <!-- Report -->
        <div style="display: flex;" v-if="item.screenName == $t('Toolbar.Reporterror') && item.isShow == true">
          <gui_tab_item id="c6c5f5" v-model="activeMenuId" active_id="Report"
            :isDisabel="!config.reportError.isActive || !item.hasPrivilege" @input="clickMenu">
            <template slot="icon">
              <svg id="c20908" class="icon" t="1717122176214" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5317" width="1.428rem" height="1.428rem">
                <path id="c05750"
                  d="M715.648 478.165333a224.341333 224.341333 0 0 1-157.738667-63.786666 213.76 213.76 0 0 1-65.28-153.941334 213.76 213.76 0 0 1 65.28-154.026666A224.298667 224.298667 0 0 1 715.648 42.666667c59.562667 0 115.584 22.613333 157.696 63.786666A213.76 213.76 0 0 1 938.666667 260.437333a213.76 213.76 0 0 1-65.322667 153.941334 224.341333 224.341333 0 0 1-157.696 63.786666z m0-389.674666c-97.109333 0-176.128 77.141333-176.128 171.946666 0 94.762667 79.018667 171.904 176.128 171.904 97.066667 0 176.085333-77.141333 176.085333-171.946666 0-94.762667-79.018667-171.946667-176.085333-171.946667z"
                  p-id="5318"></path>
                <path id="cbd9e5"
                  d="M704.597333 896H155.733333C116.906667 896 85.333333 865.152 85.333333 827.264V217.685333c0-37.888 31.573333-68.736 70.4-68.736h420.693334l-17.493334 33.322667a166.613333 166.613333 0 0 0-19.413333 78.122667c0 94.805333 79.018667 171.946667 176.128 171.946666 10.197333 0 20.565333-0.981333 31.701333-2.986666l27.690667-4.906667v402.773333c0 37.973333-31.573333 68.778667-70.4 68.778667zM155.733333 194.773333c-12.928 0-23.466667 10.24-23.466666 22.912v609.578667c0 12.629333 10.538667 22.912 23.466666 22.912h548.906667c12.928 0 23.466667-10.24 23.466667-22.912v-349.44a224.341333 224.341333 0 0 1-170.154667-63.402667 213.76 213.76 0 0 1-54.954667-219.648H155.733333z"
                  p-id="5319"></path>
                <path id="c68987" d="M613.973333 329.642667l167.04-163.2 33.194667 32.426666-167.04 163.2z" p-id="5320">
                </path>
                <path id="c8512c"
                  d="M613.973333 198.826667l33.194667-32.426667 167.04 163.242667-33.237333 32.426666L613.973333 198.826667zM238.336 347.989333h200.448V393.813333H238.378667V347.989333z m0 151.552h385.28v45.866667h-385.28v-45.866667z m0 151.552h385.28v45.866667h-385.28V651.093333z"
                  p-id="5321"></path>
              </svg>
            </template>
            <div id="cdbd3a" v-if="item.hasPrivilege" class="uKD8C77" myData="测试">{{ $t('Toolbar.Reporterror') }}</div>
            <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
              <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试">{{ $t('Toolbar.Reporterror') }}</div>
            </el-popover>
          </gui_tab_item>
        </div>
          <!-- Risk Scanning -->
        <div style="display: flex;" v-if="item.screenName == 'Risk Scan' && item.isShow == true">
          <gui_tab_item id="c6c5f5" v-model="activeMenuId" active_id="riskScanning"
            :isDisabel="!config.riskScanning.isActive || !item.hasPrivilege" @input="clickMenu">
            <template slot="icon">
             <svg t="1763103021094" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8015"  width="1.24rem" height="1.24rem"><path d="M511.232 964.864c-61.056 0-120.32-11.904-176.128-35.584-53.888-22.784-102.272-55.424-143.744-96.896-41.472-41.472-74.112-89.856-96.896-143.744C70.784 632.832 58.88 573.568 58.88 512.512c0-53.504 9.216-105.856 27.52-155.776 0.256-0.768 1.024-1.152 1.664-1.152 0.256 0 0.512 0 0.64 0.128l45.824 17.792c0.896 0.384 1.408 1.408 1.024 2.304-16 43.776-24.064 89.856-24.064 136.704 0 220.288 179.328 399.616 399.616 399.616s399.616-179.328 399.616-399.616S731.392 112.896 511.104 112.896h-2.304c-93.696 0.512-184.576 34.048-255.744 94.464l-5.248 4.48 61.44 61.312 4.48-3.712c56.064-45.824 124.416-70.144 197.504-70.144 83.584 0 162.176 32.512 221.312 91.776C791.68 350.208 824.32 428.8 824.32 512.384c0 83.584-32.512 162.176-91.776 221.312-29.184 29.184-63.36 52.096-101.632 67.84-38.144 15.872-78.464 23.808-119.808 23.808-83.584 0-162.304-32.64-221.312-91.776-59.136-59.136-91.776-137.728-91.776-221.312 0-36.096 6.144-71.68 18.176-105.472 0.256-0.768 1.024-1.152 1.664-1.152 0.256 0 0.512 0 0.64 0.128l45.824 17.792c0.896 0.384 1.408 1.408 1.024 2.304-9.728 27.648-14.72 56.704-14.72 86.4 0 143.616 116.736 260.352 260.352 260.352 140.672 0 257.408-114.304 260.352-254.848 1.536-70.272-24.448-136.576-73.088-186.88-48.64-50.176-114.048-78.208-184.32-78.976h-2.816c-58.112 0-113.152 18.688-158.848 54.016l-5.76 4.48 64.64 64.64 4.352-2.944c28.032-19.2 61.056-29.44 95.616-29.44 93.568 0 169.728 76.16 169.728 169.728 0 45.44-17.664 88.064-49.664 120.064S556.8 682.24 511.36 682.24c-93.568 0-169.728-76.16-169.728-169.728 0-18.432 2.944-36.352 8.576-53.504 0.256-0.896 1.024-1.28 1.664-1.28 0.256 0 0.384 0 0.64 0.128l45.952 17.792c0.896 0.384 1.28 1.28 1.024 2.176-3.456 11.008-5.248 22.784-5.248 34.56 0 64.512 52.48 116.992 116.992 116.992 32 0 61.824-12.672 84.096-35.84 22.272-23.04 33.92-53.376 32.896-85.376-2.176-62.208-52.736-111.744-115.072-112.768h-1.92c-19.072 0-38.016 4.608-54.528 13.44l-7.68 4.096 75.008 75.008c0.384 0.384 0.512 1.024 0.512 1.28 0 0.256-0.128 0.768-0.512 1.28l-34.816 34.816c-0.384 0.384-1.024 0.512-1.28 0.512-0.256 0-0.768-0.128-1.28-0.512L191.36 230.016c-10.24-10.24-10.24-27.008 0-37.376 41.472-41.472 89.856-74.112 143.744-96.896C390.912 72.064 450.176 60.16 511.232 60.16c61.056 0 120.32 11.904 176.128 35.584 53.888 22.784 102.272 55.424 143.744 96.896 41.472 41.472 74.112 89.856 96.896 143.744 23.552 55.68 35.584 114.944 35.584 176.128 0 61.056-11.904 120.32-35.584 176.128-22.784 53.888-55.424 102.272-96.896 143.744-41.472 41.472-89.856 74.112-143.744 96.896-55.808 23.68-115.072 35.584-176.128 35.584z" p-id="8016" fill="#333333"></path></svg>
            </template>
            <div id="cdbd3a" v-if="item.hasPrivilege" class="uKD8C77" myData="测试">{{ item.screenName }}</div>
            <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
              <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试">{{ item.screenName }}</div>
            </el-popover>
          </gui_tab_item>
        </div>
          <!-- Risk Scanning -->
    
        <!-- Share -->
        <!-- <div style="display: flex;" v-if="item.screenName == $t('Toolbar.Share') && item.isShow == true">
          <gui_tab_item id="ccba1d" v-model="activeMenuId" active_id="Share"
            :isDisabel="!config.share.isActive || !item.hasPrivilege" @input="clickMenu">
            <template id="ca5c3c" slot="icon">
              <svg id="c8cc2b" class="icon" t="1716272339061" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5900" width="1.2428rem" height="1.2428rem">
                <path id="cc1663"
                  d="M512 660.6c-11.3 0-19.9 8.8-19.9 20.6 0 10.8 9.1 19.9 19.9 19.9 10.8 0 19.9-9.1 19.9-19.9 0-11.5-8.7-20.6-19.9-20.6zM512 745.2c-6.9 0-13.6-1.1-19.9-3.3-29.7 62.9-44.7 105.1-44.7 125.4 0 16.3 18.6 31.3 32.6 41.2 9 6.2 19.5 11.6 31.9 16.6 12-5 22.5-10.5 32.1-16.7 15.5-10.9 33.2-25.4 33.2-41.1 0-19.9-16.7-66.7-44.7-125.5-6.6 2.3-13.4 3.4-20.5 3.4z"
                  fill p-id="5901"></path>
                <path id="ccfcf8"
                  d="M512 98.2c-134.5 0-243.9 109.1-243.9 243.2 0 80.7 43.2 160.5 110.1 203.4l15.1 9.7-16.7 6.6C239.3 615.6 147 751.7 147 899.8c0 14.2 11.1 25.3 25.3 25.3 14 0 24.6-10.9 24.6-25.3 0-173.4 141.4-314.4 315.1-314.4 134.5 0 243.9-109.4 243.9-243.9 0-134.2-109.4-243.3-243.9-243.3z m136.4 379.6c-36.7 36.7-85.1 56.9-136.4 56.9-51.2 0-99.7-20.2-136.4-56.9s-56.9-85.1-56.9-136.4c0-51.2 20.2-99.7 56.9-136.4s85.1-56.9 136.4-56.9c51.2 0 99.7 20.2 136.4 56.9s56.9 85.1 56.9 136.4c0 51.3-20.2 99.7-56.9 136.4zM733.9 610l-0.3-0.2c-5.5-4.6-12.2-6.5-18.8-5.6-6.5 0.9-12.1 4.4-15.9 9.8l-0.5 0.6c-10.3 12.5-5.3 27 4.2 35.8 39.3 30.3 70.1 67.3 91.5 109.8 21.8 43.3 32.9 90.2 32.9 139.5 0 14.4 10.6 25.3 24.6 25.3 14.4 0 25.3-10.9 25.3-25.3 0.1-113.8-53.4-222.1-143-289.7z"
                  fill p-id="5902"></path>
              </svg>
            </template>
            <div id="c82736" myData="测试" class="uKD8C77">{{$t('Toolbar.Share') }}</div>
          </gui_tab_item>
        </div> -->

      </div>
      <!-- ... -->
      <gui_tab_item id="c22989" v-model="activeMenuId" class="uSiB38S" active_id="more">
        <template slot="icon">

        </template>

        <el-dropdown id="cac680" class="u994i9a" trigger="click" placement="bottom">
          <div id="c68926" class="el-dropdown-link u324ce">

            <svg id="c48750" class="icon uN6u9bI ukfmqKe" t="1716968163555" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="5031" width="20px" height="1.5em">
              <path id="c4ae6c" d="M128 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#186AB3" p-id="5032">
              </path>
              <path id="c301ae" d="M512 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#186AB3" p-id="5033">
              </path>
              <path id="ceb75c" d="M896 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#186AB3" p-id="5034">
              </path>
            </svg>
          </div>
          <div id="c65b56" slot="dropdown">
            <!-- 自定义管理工具 -->
            <!-- <el-dropdown-menu id="c30e13" class="uWDPJiJ">
              <div id="gd5a26">
                <div id="c164a7" class="ud0e75">
                  <div id="c9e046" class="uc5ba9 uKD8C77">Tool</div>
                </div>
                <div id="gfc1c3" class="u8d45c uKD8C77">System Icon</div>
                <div id="g98171" class="u47dc6">

                  <div id="ge8b4f" v-for="(item, index) in queryList" :class="item.isShow ? 'active' : ''"
                    class="u1aaaf" :key="index">
                    <div id="ge8177" class="u4646c">
                      <div id="g500c6" v-if="item.icon" v-html="item.icon"></div>
                    </div>
                    <div id="c056cc" class="uUgrpts ukBgk9n" myData="测试" @click="addTool(item)">
                      {{ item.screenName }}
                    </div>
                    <div v-if="item.isShow " @click="DeelteTool(item)">
                      <svg t="1743475052847" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20091" width="20" height="20"><path d="M512 32A480 480 0 1 0 992 512 480.512 480.512 0 0 0 512 32z m0 896A416 416 0 1 1 928 512 416.512 416.512 0 0 1 512 928z" p-id="20092" fill="#f56b6b"></path><path d="M670.4 353.6a32 32 0 0 0-45.248 0L512 466.752 398.848 353.6a32 32 0 1 0-45.248 45.248L466.752 512 353.6 625.152a32 32 0 1 0 45.248 45.248L512 557.248l113.152 113.152a32 32 0 0 0 45.248-45.248L557.248 512l113.152-113.152a32 32 0 0 0 0-45.248z" p-id="20093" fill="#f56b6b"></path></svg>
                    </div>
                  </div>
                </div>

              </div>
            </el-dropdown-menu> -->
            <el-dropdown-menu id="c30e13" class="uWDPJiJ">
              <div id="gd5a26">
                 <div style="display: flex;" v-for="(item, index) in queryList" @click="powermethod(item)" :key="index">
    <!--  Credit Assessment-->
         <div style="display: flex;margin-top: 10px;" v-if="item.screenName == 'Credit Assessment' && item.isShow == true">
          <gui_tab_item id="c6c5f5" v-model="activeMenuId" active_id="creditAssessment"
            :isDisabel="!config.creditAssessment.isActive || !item.hasPrivilege" @input="clickMenu">
            <template slot="icon">
          <svg t="1763103208981" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8525" width="1.34rem" height="1.34rem"><path d="M899.428332 219.960691c0-14.872732-11.900028-26.955932-26.694989-27.273157-0.390903-0.13303-0.615007-0.201591-0.615007-0.201591l-202.833615 21.404496c0 0-0.759293 0.056282-1.992377 0.056282-2.820232 0-8.108678-0.288572-12.429077-2.187829-6.208399-2.729158-10.394744-8.077979-10.394744-8.077979L531.569196 72.760141l-0.092098-0.001023c-4.990664-5.475711-12.178367-8.911974-20.172435-8.911974-7.608282 0-14.486946 3.116991-19.435655 8.138354l-0.276293-0.004093L377.031541 204.051349c0 0-4.325515 5.185093-10.131755 7.961322-3.458775 1.653663-8.06263 1.987261-11.219529 1.987261-2.14485 0-3.621481-0.153496-3.621481-0.153496L149.64267 192.486966c0 0-0.223081 0.068562-0.61296 0.202615-14.794961 0.316202-26.693965 12.400425-26.693965 27.273157 0 0.098237 0.00614 0.195451 0.00614 0.292666-0.267083 64.383356 7.202029 218.378659 76.986395 343.589382 90.707908 162.751734 227.993644 210.755028 282.328134 227.142254l0 168.170141 59.72015 0L541.376563 790.984992c54.333466-16.388249 190.350302-64.390519 281.059234-227.143277 69.786413-125.214816 77.253478-279.218306 76.982302-343.597569C899.423215 220.150002 899.428332 220.056881 899.428332 219.960691L899.428332 219.960691zM778.18599 540.661783c-34.646078 62.163805-79.233576 111.272269-132.525316 145.95928-45.393863 29.550013-86.705757 42.007743-108.900246 48.702212-11.494799 3.466961-20.553105 5.573949-25.263383 16.038278-4.708232-10.464329-13.765515-12.571317-25.260314-16.038278-22.410406-6.757914-64.122413-19.339464-109.61963-48.76668-53.671387-34.716686-98.432847-83.800591-133.040039-145.893788-56.497759-101.372805-67.791989-225.874377-69.437465-292.038286 2.556219-1.63422 4.810562-3.693112 6.66991-6.078439l171.506119 18.098193c0.017396 0.002047 0.035816 0.00307 0.053212 0.005117 1.061169 0.110517 3.937682 0.36839 7.718799 0.36839 10.654664 0 20.204158-1.984191 28.385491-5.897314 11.855002-5.67014 19.931958-14.158465 23.150256-17.940604l95.340415-109.915365c1.409093 0.232291 2.855024 0.356111 4.328585 0.356111 1.412163 0 2.793626-0.11154 4.146437-0.324388l94.133937 109.158119c3.668553 4.460592 12.095479 13.332656 24.892947 18.957771 10.438747 4.586458 21.196765 5.550413 28.383444 5.550413 2.321882 0 4.051269-0.100284 4.876054-0.159636 0.438998-0.031722 0.876973-0.072655 1.314948-0.116657l171.912371-18.142196c1.858324 2.387373 4.113691 4.445242 6.668886 6.078439C845.977979 314.786383 834.683748 439.290001 778.18599 540.661783L778.18599 540.661783z" fill="#333333" p-id="8526"></path><path d="M429.618223 942.094572c-8.402367 0-16.561188-4.394077-21.008476-12.193717-30.724769-53.79316-80.70816-123.07713-144.166447-147.683551-25.814945-9.995655-60.58075-11.558244-90.731444-4.117784-18.672268 4.614088-51.900044 16.968463-64.833611 47.752584-5.161556 12.301164-19.305695 18.10024-31.606859 12.93766-12.304234-5.166673-18.09717-19.305695-12.933567-31.611975 15.625886-37.260625 50.363038-64.22679 97.78714-75.954903 39.873126-9.859555 84.634586-7.630794 119.756501 5.958712 34.490535 13.374612 67.991534 37.621852 99.626022 72.114434 24.328082 26.498514 47.561225 59.039651 69.062935 96.65741 6.619768 11.589966 2.580778 26.338878-9.008164 32.955576C437.77602 941.051823 433.655166 942.094572 429.618223 942.094572L429.618223 942.094572 429.618223 942.094572z" fill="#333333" p-id="8527"></path><path d="M596.190983 942.094572c-4.015454 0-8.060583-1.030469-11.802814-3.14769-11.453866-6.53995-15.443737-21.113877-8.901741-32.567743 21.249977-37.202297 44.206828-69.334111 68.25043-95.520517 31.263028-34.086329 64.371076-58.049091 98.42773-71.266114 34.710546-13.43294 78.970586-15.631002 118.375038-5.888104 46.865377 11.587919 81.196277 38.237883 96.637967 75.060533 5.099135 12.159948-0.62524 26.13217-12.783141 31.238468-12.157901 5.101181-26.131147-0.627287-31.234375-12.785188-12.780071-30.420847-45.617967-42.63196-64.072271-47.188742-29.795607-7.353478-64.151066-5.809309-89.662089 4.069689-62.714344 24.315802-112.104217 92.783173-142.469805 145.945977C612.555695 937.752684 604.496136 942.094572 596.190983 942.094572L596.190983 942.094572 596.190983 942.094572z" fill="#333333" p-id="8528"></path></svg>
            </template>
            <div id="cdbd3a" v-if="item.hasPrivilege" class="uKD8C77" myData="测试">{{ item.screenName }}</div>
            <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
              <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试">{{ item.screenName }}</div>
            </el-popover>
          </gui_tab_item>
        </div>
          <!-- dataAnalysis -->
        <div style="display: flex;" class="margin-bottom15 margin-top15" v-if="item.screenName == 'Data Analysis' && item.isShow == true">
          <gui_tab_item id="c6c5f5" v-model="activeMenuId" active_id="dataAnalysis"
            :isDisabel="!config.dataAnalysis.isActive || !item.hasPrivilege" @input="clickMenu">
            <template slot="icon">
           <svg t="1763103322274" class="icon" viewBox="0 0 1112 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8783" width="1.34rem" height="1.34rem"><path d="M1046.556427 70.759203H565.146651V16.067592a16.067592 16.067592 0 0 0-16.067592-16.067592h-21.011467a16.067592 16.067592 0 0 0-16.067592 16.067592v54.691611H65.815329A65.506337 65.506337 0 0 0 0 136.26554V710.681955a65.506337 65.506337 0 0 0 65.815329 65.506337h401.689801l-130.085697 170.872662a34.916113 34.916113 0 0 0 0 44.185878 23.792396 23.792396 0 0 0 37.38805 0l154.496078-203.62583v-1.544961 211.041642a26.573325 26.573325 0 0 0 53.14665 0v-201.153893L741.581171 986.302957a24.101388 24.101388 0 0 0 37.079058 2.471937 35.225106 35.225106 0 0 0 2.162945-44.185878l-139.973446-168.091732h405.706699A65.506337 65.506337 0 0 0 1112.371756 710.681955V136.26554a65.506337 65.506337 0 0 0-65.815329-65.506337zM1059.534098 710.681955a12.97767 12.97767 0 0 1-12.977671 12.668679H65.815329a12.97767 12.97767 0 0 1-12.977671-12.668679V136.26554A12.668678 12.668678 0 0 1 65.815329 123.596862h980.741098a12.668678 12.668678 0 0 1 12.977671 12.668678z" fill="#333333" p-id="8784"></path><path d="M905.038021 233.907061h-238.541944a26.573325 26.573325 0 0 0 0 53.146651h238.541944a26.573325 26.573325 0 0 0 0-53.146651zM905.038021 357.503923h-238.541944a26.573325 26.573325 0 0 0 0 53.14665h238.541944a26.573325 26.573325 0 0 0 0-53.14665z" fill="#333333" p-id="8785"></path><path d="M639.922752 481.100785l251.519614 0 0 52.837658-251.519614 0 0-52.837658Z" fill="#333333" p-id="8786"></path><path d="M639.922752 604.697646l198.681955 0 0 52.837659-198.681955 0 0-52.837659Z" fill="#333333" p-id="8787"></path><path d="M326.604707 591.410984a167.78274 167.78274 0 1 1 0-335.256488V203.007846a220.92939 220.92939 0 1 0 220.620399 220.620398H494.387447a168.091732 168.091732 0 0 1-167.78274 167.78274z" fill="#333333" p-id="8788"></path><path d="M372.95353 406.015691h132.248643a28.427278 28.427278 0 0 0 28.118286-33.989137c-11.741702-58.090525-48.82076-170.254677-157.585999-178.288473a29.045263 29.045263 0 0 0-30.899216 28.73627v154.496077a28.73627 28.73627 0 0 0 28.118286 29.045263z" fill="#333333" p-id="8789"></path></svg>
            </template>
            <div id="cdbd3a" v-if="item.hasPrivilege" class="uKD8C77" myData="测试">{{ item.screenName }}</div>
            <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
              <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试">{{ item.screenName }}</div>
            </el-popover>
          </gui_tab_item>
        </div>
          <!-- customPortfolio -->
        <div style="display: flex;"  class="margin-bottom15" v-if="item.screenName == 'New Portfolio' && item.isShow == true">
          <gui_tab_item id="c6c5f5" v-model="activeMenuId" active_id="customPortfolio"
            :isDisabel="!config.customPortfolio.isActive || !item.hasPrivilege" @input="clickMenu">
            <template slot="icon">
           <svg t="1763103398375" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8994" width="1.34rem" height="1.34rem"><path d="M426.556947 528.587141l-327.647235-183.328867a33.430257 33.430257 0 0 0-20.785121-4.761124c-25.59744 0-46.075392 23.805619-46.075393 50.017399v354.780521a104.488751 104.488751 0 0 0 48.481552 88.10639l325.292271 183.328867a33.430257 33.430257 0 0 0 20.477952 4.761124 51.450855 51.450855 0 0 0 46.075392-52.372363v-357.186681a90.10299 90.10299 0 0 0-46.075392-83.345266z m-324.831517 240.20638c-7.013699-5.119488-9.368663-12.952305-9.368663-23.293671V408.944706l308.346766 176.366363c7.064894 5.119488 9.419858 12.952305 9.419858 23.293671v341.213878l-308.346766-181.025097zM943.471656 343.005699a64.710329 64.710329 0 0 0-20.785122 4.761124l-325.39466 183.328867a104.642336 104.642336 0 0 0-48.430357 88.10639v354.780522c0 26.211779 18.481352 50.017398 46.075392 50.017398a66.092591 66.092591 0 0 0 20.785122-4.761124l325.343465-183.380062A100.751525 100.751525 0 0 0 991.902013 747.445255V392.920708c-2.30377-28.566743-20.785121-50.017398-48.481552-50.017398z m-12.030797 412.374763a28.464354 28.464354 0 0 1-10.238976 23.344865l-308.090791 172.475553v-338.961304a28.361964 28.361964 0 0 1 10.238976-23.293671l308.090791-172.885111v339.217278z m-17.969403-526.795321a32.20158 32.20158 0 0 0-20.785122-35.836416l-332.254774-180.820318A120.819918 120.819918 0 0 0 511.950008 0c-16.126387 2.406159-34.607739 4.761124-50.785321 11.928407l-332.254775 178.567743a41.723828 41.723828 0 0 0-23.088891 35.836417c0 16.638336 6.911309 30.716928 20.785121 35.836416l332.254775 178.618938a122.867713 122.867713 0 0 0 50.785321 11.877212c16.126387-2.354965 34.607739-4.761124 50.785322-11.877212l332.254774-176.212779c13.873813-7.167283 23.088891-21.450655 20.785122-35.836416zM492.239979 384.729527L175.497253 224.387161l313.0055-161.673432a43.413259 43.413259 0 0 1 36.757924 0l319.712029 166.588141-316.025998 155.427657a36.911509 36.911509 0 0 1-18.327767 5.426657 47.252875 47.252875 0 0 1-18.378962-5.426657z" p-id="8995" fill="#333333"></path></svg>
            </template>
            <div id="cdbd3a" v-if="item.hasPrivilege" class="uKD8C77" myData="测试">{{ item.screenName }}</div>
            <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
              <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试">{{ item.screenName }}</div>
            </el-popover>
          </gui_tab_item>
        </div>
         <div style="display: flex;"  class="margin-bottom15" v-if="item.screenName == 'Print' && item.isShow == true">
          <gui_tab_item id="c6c5f5" v-model="activeMenuId" active_id="print"
            :isDisabel="!config.print.isActive || !item.hasPrivilege" @input="clickMenu">
            <template slot="icon">
             <svg t="1763103437856" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9200" width="1.34rem" height="1.34rem"><path d="M789.333333 298.666667h-21.333333v-58.666667A69.546667 69.546667 0 0 0 698.666667 170.666667h-373.333334A69.546667 69.546667 0 0 0 256 240V298.666667h-21.333333a128 128 0 0 0-128 128v192a128 128 0 0 0 128 128h21.333333v75.52A95.146667 95.146667 0 0 0 351.146667 917.333333h321.706666A95.146667 95.146667 0 0 0 768 822.186667V746.666667h21.333333a128 128 0 0 0 128-128v-192a128 128 0 0 0-128-128z m-490.666666-58.666667A26.666667 26.666667 0 0 1 325.333333 213.333333h373.333334A26.666667 26.666667 0 0 1 725.333333 240V298.666667H298.666667z m426.666666 582.186667A52.693333 52.693333 0 0 1 672.853333 874.666667H351.146667A52.693333 52.693333 0 0 1 298.666667 822.186667v-193.706667A52.693333 52.693333 0 0 1 351.146667 576h321.706666A52.693333 52.693333 0 0 1 725.333333 628.48zM874.666667 618.666667a85.333333 85.333333 0 0 1-85.333334 85.333333h-21.333333v-75.52A95.146667 95.146667 0 0 0 672.853333 533.333333H351.146667A95.146667 95.146667 0 0 0 256 628.48V704h-21.333333a85.333333 85.333333 0 0 1-85.333334-85.333333v-192a85.333333 85.333333 0 0 1 85.333334-85.333334h554.666666a85.333333 85.333333 0 0 1 85.333334 85.333334z" fill="#333333" p-id="9201"></path><path d="M784 395.306667h-103.68a21.333333 21.333333 0 0 0 0 42.666666h103.68a21.333333 21.333333 0 0 0 0-42.666666z" fill="#333333" p-id="9202"></path></svg>
            </template>
            <div id="cdbd3a" v-if="item.hasPrivilege" class="uKD8C77" myData="测试">{{ item.screenName }}</div>
            <el-popover v-else placement="top-start" :disabled="true" width="200" trigger="hover">
              <div slot="reference" id="c15095" class="uUgrpts uKD8C77" myData="测试">{{ item.screenName }}</div>
            </el-popover>
          </gui_tab_item>
        </div>
        <!-- Share -->
        <div style="display: flex;" class="margin-bottom15" v-if="item.screenName == $t('Toolbar.Share') && item.isShow == true">
          <gui_tab_item id="ccba1d" v-model="activeMenuId" active_id="Share"
            :isDisabel="!config.share.isActive || !item.hasPrivilege" @input="clickMenu">
            <template id="ca5c3c" slot="icon">
              <svg id="c8cc2b" class="icon" t="1716272339061" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5900" width="1.2428rem" height="1.2428rem">
                <path id="cc1663"
                  d="M512 660.6c-11.3 0-19.9 8.8-19.9 20.6 0 10.8 9.1 19.9 19.9 19.9 10.8 0 19.9-9.1 19.9-19.9 0-11.5-8.7-20.6-19.9-20.6zM512 745.2c-6.9 0-13.6-1.1-19.9-3.3-29.7 62.9-44.7 105.1-44.7 125.4 0 16.3 18.6 31.3 32.6 41.2 9 6.2 19.5 11.6 31.9 16.6 12-5 22.5-10.5 32.1-16.7 15.5-10.9 33.2-25.4 33.2-41.1 0-19.9-16.7-66.7-44.7-125.5-6.6 2.3-13.4 3.4-20.5 3.4z"
                  fill p-id="5901"></path>
                <path id="ccfcf8"
                  d="M512 98.2c-134.5 0-243.9 109.1-243.9 243.2 0 80.7 43.2 160.5 110.1 203.4l15.1 9.7-16.7 6.6C239.3 615.6 147 751.7 147 899.8c0 14.2 11.1 25.3 25.3 25.3 14 0 24.6-10.9 24.6-25.3 0-173.4 141.4-314.4 315.1-314.4 134.5 0 243.9-109.4 243.9-243.9 0-134.2-109.4-243.3-243.9-243.3z m136.4 379.6c-36.7 36.7-85.1 56.9-136.4 56.9-51.2 0-99.7-20.2-136.4-56.9s-56.9-85.1-56.9-136.4c0-51.2 20.2-99.7 56.9-136.4s85.1-56.9 136.4-56.9c51.2 0 99.7 20.2 136.4 56.9s56.9 85.1 56.9 136.4c0 51.3-20.2 99.7-56.9 136.4zM733.9 610l-0.3-0.2c-5.5-4.6-12.2-6.5-18.8-5.6-6.5 0.9-12.1 4.4-15.9 9.8l-0.5 0.6c-10.3 12.5-5.3 27 4.2 35.8 39.3 30.3 70.1 67.3 91.5 109.8 21.8 43.3 32.9 90.2 32.9 139.5 0 14.4 10.6 25.3 24.6 25.3 14.4 0 25.3-10.9 25.3-25.3 0.1-113.8-53.4-222.1-143-289.7z"
                  fill p-id="5902"></path>
              </svg>
            </template>
            <div id="c82736" myData="测试" class="uKD8C77">{{$t('Toolbar.Share') }}</div>
          </gui_tab_item>
        </div>

      </div>

              </div>
            </el-dropdown-menu> 
        
          </div>
        </el-dropdown>
      </gui_tab_item>
  
    </gui_tabs>
    <el-dialog :visible.sync="Share" center :close-on-click-modal="true" @close="closeDialog"
      custom-class="dialog_normalsuo" :append-to-body="true">
      <div>
        <div class="detail_cont">
              <div class="flex_center margin-bottom20"><img style="width: 5.7142857rem;height: 4.57142857rem;" src="../../../assets/dialogIcoImg/shareIcon.png" alt=""></div>
          <h3>{{ $t('ListofResults.Sharethisinformation') }}</h3>
          <h4>To</h4>
          <!-- <div class="CollecInput website">
            <el-input autocomplete="off" placeholder="https://csibizsearch.com" :disabled="true" v-model="website">
              <el-button slot="append" @click="WebAdd" style="font-size: 1.42857143rem;">Copy Link</el-button>
            </el-input>

          </div> -->
          <div class=" website">
                      <el-input
            type="textarea"
            :rows="4"
            placeholder="Please enter one or more email address: 
Example: xxx@xxx.com; xxxx@xxxx.com"
            :max="200"
             maxlength="200"
             show-word-limit
            v-model="textShare">
          </el-input>
          </div>
          <h4>{{ $t('ListofResults.message') }}</h4>
          <div class=" website">
                      <el-input
            type="textarea"
            :rows="4"
            :placeholder="$t('ListofResults.pleaseleaveamessage') "
            :max="200"
             maxlength="200"
             show-word-limit
            v-model="textShareMessage">
          </el-input>
          </div>
          <h4 class="flex_center_start_box ShareBox">{{ $t('ListofResults.Include') }} 
            <el-checkbox-group v-model="shareCheckList" class="margin-left20">
    <el-checkbox label="1">{{ $t('ListofResults.thisaddress') }} </el-checkbox>
    <el-checkbox label="2">{{ $t('ListofResults.CSIwebsite') }}</el-checkbox>

  </el-checkbox-group>
</h4>
          
          <!-- <a href="mailto:''?subject=Send website link to friends&body=https://csibizsearch.com"><el-button
              slot="append" class="btn_export btnbox">Send an Email</el-button></a> -->
          <!--  -->
        </div>
      </div>
        <div class="flex_center margin-top20">
          <el-button class="btn_export btnbox btn_exporthui button-210" @click="closeDialog">{{ $t('MyAccount.Cancel') }}</el-button>
          <el-button class="btn_export btnbox button-210" :class="textShare==''?'btn_exporthui':'btn_export btnbox'" :disabled="textShare==''" @click="SedingShare">Sending</el-button>
        </div>

    </el-dialog>
      <Custom :showReport="showReportIndex" :myDataMnegent="false" :CustomObj="CustomObj" @closeReportDialog="closeDialog3($event)"></Custom>
  </div>
  <!--srcviewscompanycomponenttoolsvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import { getEditqueryList,addEditqueryList} from "@/api/companyApi";
import { getCollectionList, addItems, showItems, creates, getqueryList, getqueryaddList, getqueryremoveList,sharingInformation } from "@/api/userApi";
import Custom from "../../../components/CustomPortfolio/Custom.vue";
import gui_tab_item from "../../../components/gui_tabs/gui_tab_item.vue";
import gui_tabs from "../../../components/gui_tabs/gui_tabs.vue";
//importEnd

export default {
  name: "",

  props: {
    UpdateStatus: {
      type: Number,
      default: 0
    },
     DownloadStatus: {
      type: Number,
      default: 0
    },
    // 基础配置
    config: {
      type: Object,
      default: {
        "Optimize": {
          "isShow": true,
          "isActive": true
        },
        menu: {
          isShow: true,
          isActive: true,
        },
        filter: {
          isShow: true,
          isActive: true,
        },
        select: {
          isShow: true,
          isActive: true,
        },
        edit: {
          isShow: true,
          isActive: true,
        },
        sort: {
          isShow: true,
          isActive: true,
        },
        collect: {
          isShow: true,
          isActive: true,
        },
        saved: {
          isShow: true,
          isActive: true,
        },
        compare: {
          isShow: true,
          isActive: true,
        },
        export: {
          isShow: true,
          isActive: true,
        },
        download: {
          isShow: true,
          isActive: true,
        },
        update: {
          isShow: true,
          isActive: true,
        },
        reportError: {
          isShow: true,
          isActive: true,
        },
          riskScanning: {
          isShow: true,
          isActive: true,
        },
          creditAssessment: {
          isShow: true,
          isActive: true,
        },
          dataAnalysis: {
          isShow: true,
          isActive: true,
        },
          customPortfolio: {
          isShow: true,
          isActive: true,
        },
          print: {
          isShow: true,
          isActive: true,
        },
        share: {
          isShow: true,
          isActive: true,
        },
      },
    },

  },
  created() {

  },
  mounted() {
  },

  watch: {
     '$i18n.locale': {
      handler(newVal, oldVal) {
    this.getqueryList()
       this.getEditkList();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    '$store.state.app.SearchagAin': {
      handler(newVal, oldVal) {
        // 在这里处理columns属性的变化
        if (newVal) {
          this.activeSavedId = ''

        }
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    '$store.state.app.collectList': {
      handler(newVal, oldVal) {
        // 在这里处理columns属性的变化
        if (newVal) {

       if(newVal.length==0){
        this.checkList=[]
       }

        }
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    token: {
      handler(newVal, oldVal) {
        if (newVal) {
          // this.openMenu = ['2', '3', '4', '5', '6', '7', '8'];
        } else {

        }
      },
      immediate: true,
    },

  },
  components: {
    // gui_tabs start
    gui_tabs,
    gui_tab_item,
    Custom
    // gui_tab_item end
  },
  data() {
    return {
      textShare:'',
      textShareMessage:'',
      shareCheckList:['1'],
          CustomObj: {
                groupTask: '',
                executorName: '',
                portfolioName: '',
                userName: '',
                id: ""
            },
      showReportIndex:false,
      background: 'background-color:',
      website: 'https://csibizsearch.com',
      CollectAdd: "",
      CollectShow: false,
      checkList: [],
    
      json_fields: {
        'Company Name': 'company_name_en',
        'Reg. Name': 'company_name',
        'Co. Type': 'company_type_en',
        'Reg. Status': 'status_en',
        'State/Province': 'province_en',
        'Inc.Yr.': 'incorporation_year',
        'City/Country': 'city_en',
        'District/City': 'district_en',
      },
      Editoptions: [

      ],
      DetailsForm: [],
      // activeMenuId
      activeMenuId: "all",
      // isOpenSelect
      isOpenSelect: false,
      // isOpenSlct
      isOpenSlct: false,
      Share: false,
      // 默认列
      defaultColumns: [

      ],
      // 表格列表数据
      columns: [

      ],
      // cascader6Value
      cascader6Value: [
      
      ],
  
      //
      sort_listOptions: [
        {
          value: "ASC",
          label: this.$t('Toolbar.ascending'),
          disabled: false,
          children: [

          ],
        },
        {
          value: "DESC",
          label: this.$t('Toolbar.descending'),
          disabled: false,

          children: [],
        },
      ],
      //
      sortList: "",
      // rowsSlct
      rowsSlct: [],
      // 素选id
      activeFavoritesId: "",
      // 收藏列表
      favoritesList: [],
      // 素选id
      activeSavedId: "",
      // 收藏列表
      savedList: [

      ],
      SortArrlist: [],
      queryList: [
        // {
        // id:'111',
        //     screenName:'Share',
        //     isShow:false
        //   }
      ],
      UPdateshow: false,
      UPdatetype: '2',
      token: localStorage.getItem("token"),
      // srcviewscompanycomponenttoolsvueDataEnd
    };
  },
  updated() {


    window.addEventListener("setItem", () => {
      this.token = localStorage.getItem("token");
    });
  },
  destroyed() {
    window.removeEventListener('setItem', () => {
      this.token = localStorage.getItem('token');
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    // 添加分组
     closeDialog3(value) {
            this.showReportIndex = value;
        },
    // 分享确定

    // this.$store.dispatch("app/setchangeList",   this.compareList);
    SedingShare(){
let Updatelis = []
  this.$store.state.app.changeList.map((item) => {
                Updatelis.push(
                    item.aaa_id
                );
    });

          let params={
            message:this.textShareMessage,
            toEmail:this.textShare.split(";"),
            sourceEmail: JSON.parse(localStorage.getItem('userInfo'))?.userInfo?.email,
            type:this.shareCheckList,
            aaaIds:Updatelis
          }
sharingInformation(params).then(res=>{
  if(res.code==200){
    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
    
  }else{
    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
  }
  this.Share=false
})
      
    },
    powermethod(vaue) {
      if (!vaue.hasPrivilege && this.token) {
        this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
      }


    },
    // whetherDeductPointsDetail(){
    // },
    addTool(item) {

      let obj = this.queryList.find((item2) => item2.id == item.id);
      if (item.isShow == false) {
        item.isShow = true;
        getqueryaddList({
          moduleId: item.moduleId
        }).then(res => {
          // console.log(res);

        })
      }

    }, // taggleFlolwing
    DeelteTool(item) {

if (item.isShow == true) {
  item.isShow = false;
  getqueryremoveList({
    moduleId: item.moduleId
  }).then(res => {
    // console.log(res);

  })
}

},
    getqueryList() {
      getqueryList().then(res => {
        if (res.code == 200) {
          this.queryList = res.data


        }

      })
    },
    exportCompany() {
      if (this.$store.state.app.searchType == 'company') {
        this.DetailsForm = this.$store.state.app.changeList
      }
    },
    // 调用浏览器的复制操作
    WebAdd() {
      const textarea = document.createElement('textarea');
      textarea.value = this.website;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy'); // 
    },
    closeDialog() {
      this.Share = false
    },
    CheckSort(val) {
      this.clickMenu("Sort", this.sortList);

    },
    AddCollect() {
      if (this.CollectAdd == '') {

      } else {
        creates({ collectionName: this.CollectAdd }).then((res) => {
          if (res.code == 200) {
            this.CollectShow = false;
            this.$message({
              message: res.msg,
              center: true,
              type: "success",
            });
            this.getEditkList();
          }
        });
      }

    },
    ChangeSave(id) {
      this.clickMenu("Saved", id);
      this.$store.dispatch("app/SetarchagAin", false)
    },
    getEditkList() {
      getEditqueryList().then((res) => {
        if (res.code == 200) {
          this.Editoptions = res.data.map(item => {
            return {
              ...item, // 保留原始对象的其他属性
              children: item.children ? item.children.map(ite => {
                const { children, ...rest } = ite; // 解构出子节点的 children 属性
                return rest; // 返回不包含 children 的新对象
              }) : [] // 如果没有子节点，返回空数组
            };

          });
          // SortArrlist
          let sortArr = []
          this.Editoptions.map(item => {
            item.children.map(ite => {
              sortArr.push(ite)

            })
          })
          this.sort_listOptions[0].children = []
          this.sort_listOptions[1].children = []
          sortArr.map(item => {
            if (item.sortName != '') {


              this.sort_listOptions[0].children.push({
                
                value: item.sortName,
                label: item.screenName,
              })
              this.sort_listOptions[1].children.push({
                value: item.sortName,
                label: item.screenName,
              })
            }
          })
       
          let arr = []
      this.Editoptions.map(item => {
        item.children.map(ite => {
         if(ite.userEditable&&!this.cascader6Value.includes(ite.columnName)){
          this.cascader6Value.push(ite.columnName)
         }
          if (this.cascader6Value.includes(ite.columnName)) {
            arr.push(ite)
          }

        })
      })
          this.$store.dispatch("app/seColumnsArr", arr)
          this.clickMenu("edit", this.cascader6Value);
          // this.changeColumn(this.cascader6Value)
        } else {
          this.Editoptions = [];
        }
      })
      if (this.token) {
        getCollectionList().then((collect) => {
          if (collect.code == 200) {
            this.favoritesList = collect.data;
          } else {
            this.favoritesList = [];
          }
        });
      }

    },

    // 点击菜单
    clickMenu(name, data) {

      if (name == 'Share') {
        this.Share = true
      }
      if (name == 'riskScanning') {
       this.$router.push('/index/riskScan')
      }
        if (name == 'customPortfolio') {
       this.showReportIndex=true
      }
      this.$emit("clickMenu", name, data);
    },
    clickAll(name, data) {
      this.$emit("clickMenu", name, data);
    },
    CollectCheckBook() {
      this.$store.dispatch("app/setcollectList", this.checkList);

    },
    // changeMenu
    changeMenu(isMenu) {
      this.$refs.contentView.changeMenu(isMenu);
      this.isShowMenu = this.$refs.contentView.isMenu;
    }, // openMenu
    // 级联多选
    changeColumn(cascader6Value) {
      let arr = []
      let arrmoduleId=[]
      this.Editoptions.map(item => {
        item.children.map(ite => {
          if (cascader6Value.includes(ite.columnName)) {
            arr.push(ite)
            arrmoduleId.push(ite.moduleId)
          }

        })
      })

      addEditqueryList({
        moduleIds:arrmoduleId
      }).then(res=>{
        if(res.code==200){
          // this.getEditkList()
        }
      })
      this.$store.dispatch("app/seColumnsArr", arr)
      this.clickMenu("edit", cascader6Value);




    }, // 所选的值回调
    setRowsSlct(rows) {
      this.rowsSlct = rows;
    },

  },
  computed: {},
};
</script>
<style scoped>
.srcviewscompanycomponenttoolsvuecssStart {}

.uJeKUqr {
  width: 100%;
  /* padding-left: 1.5em; */
}

.usRlj2Q {
  /* margin-left: 3.21rem; */
  margin-top: -0.42rem;
  vertical-align: middle;
}

.uskVhXw {
  overflow-y: hidden;
  overflow-x: hidden;
  height: 2.42rem;
  padding: 0rem 1.2rem 0 1rem;
  color: rgb(252, 252, 252);
  /* min-width: 8.5em; */
}

.u79e9d {
  height: 1.42rem;
}

.u39929 {
  color: rgb(255, 255, 255);
  margin-right: 0.6rem;
  color: inherit;
}

.uOLnMLV {
  display: flex;
  align-items: center;
}

.ua4c9f {
  height: 4em;
  margin-right: 0.5rem;
  margin-bottom: -2rem;
  margin-top: -2rem;
  border-right-style: solid;
  border-right-width: 0.07142857142857142rem;
  border-right-color: rgb(255, 255, 255);
}

.ujOvfa4 {
  /* height: 0.5em; */
  margin-right: -0.7rem;
  /* margin-top: 0.2rem; */
}

.udVmvz8 {
  fill: #fff !important;
}

.u7d9e0 {
  display: flex;
  align-items: center;
  display: flex;
}

.u6jM1KJ {
  margin-right: 0.5rem;
}

.uhwg9v2 {
  margin-right: 0.35714285714285715rem;
}

.u6aa68 {
  margin-left: 1.4285714285714286rem;
  background-color: #8497AB !important;
  cursor: not-allowed;
  color: #fff;
}

.u2c700 {
  /* color: rgba(153, 153, 153, 1); */
  color: #fff;
  /* margin-top: 0.14285714285714285rem; */
}

.u27d59 {
  flex: auto;
}

.uupMxrD {
  display: none;
  margin-left: 0.5rem;
  margin-left: 0.5rem;
}

.u994i9a {
  color: inherit;
  width: max-content;
  color: inherit;
}

.u5c5c7 {
  flex-direction: column;
}

.u324ce {
  display: flex;
  align-items: center;
}

.unrH9VJ {
  margin-right: 0.42857142857142855rem;
}

.u606de {
  display: flex;
  align-items: center;
  /* padding-left: 1rem; */
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.u7fb7a {
  width: 1rem;
  margin-right: 0.5rem;
}

.u7fb7a10 {
  padding: 0.7142857142857143rem;
}

.ucc8d2 {
  color: rgba(26, 35, 50, 1);
  font-size: 1.1428571428571428rem;
}

.svg_update {
  color: rgba(18, 144, 201, 1);
}

.uskVhXw .no_active {}

.uoCrWss path {
  fill: hsl(0, 0%, 100%) !important;
}

/* .uc38e7 path {
  fill: #999999 !important;
} */

.u606de .active {
  color: rgba(18, 144, 201, 1);
  fill: #1290c9;
}

.u606de .active {
  color: rgba(18, 144, 201, 1);
  fill: #1290c9;
}

.svg_update path {
  fill: rgba(18, 144, 201, 1);
}

.ukfmqKe path {
  fill: black;
}

.elcheckbook {
  display: block !important;
  width: 100%;
}

.CollectBottom {
  padding: 0.35714285714285715rem 0.7142857142857143rem;
  padding-top: 1.0714285714285714rem;
  border-top: 0.07142857142857142rem solid #dddddd;
  font-size: 1.1428571428571428rem;
  display: flex;
  align-items: center;
  color: #1a2332;
}

.CollecButton {
  padding: 0.7142857142857143rem;
  padding-bottom: 0.35714285714285715rem;

  text-align: center;
}

.CollecInput {
  /* width: 80%; */
  padding: 1.2142857142857142rem 0.7142857142857143rem;
  padding-top: 0.5rem;
}

.CollecInput /deep/ .el-input-group--append .el-input__inner {
  border-right: none !important;
  border-top-left-radius: 0.7142857142857143rem;
  border-bottom-left-radius: 0.7142857142857143rem;
  border: 1px solid #CCCCCC;
}

.CollecInput /deep/ .el-input-group__append {
  background: #1290c9;
  border-radius: 0.7142857142857143rem;
  color: #fff;
  position: relative;
  left: -0.42857142857142855rem;
  height: 3rem;
}



.uvHkMZZ ,#caa1e7{
  font-size: 1.28571428571428rem;
  color: #1a2332;
}

.checkbox {
  height: 28.571428571428573rem;
  overflow-y: auto;
}


.detail_cont h4 {
  font-size: 1.2857142857142858rem;
  margin-top: 1.4285714285714286rem;
  margin-bottom: 0.71428571428571rem;
  color: #1A2332;



}

.website .el-input.is-disabled .el-input__inner {
  color: #333333 !important;
  font-size: 1.2857142857142858rem;
}

.u1aaaf {
  display: flex;
  align-items: center;
  height: 2.4285714285714284rem;
  margin-right: 1rem;
  padding-left: 1.0714285714285714rem;
  padding-right: 1.0714285714285714rem;
  padding-top: 0.8428571428571429rem;
  padding-bottom: 0.6428571428571429rem;
  margin-bottom: 1rem;
  background: #f5f5f5;
  border-radius: 0.2857142857142857rem;
}

.ud0e75 {
  /* padding-top: 1.4285714285714286rem; */
  padding-bottom: 1rem;
}

.u8d45c {
  color: #1290c9;
  font-size: 1.1428571428571428rem;
  margin-bottom: 0.7142857142857143rem;
  font-weight: normal;
  text-align: left;
  line-height: 0.8571428571428571rem;
  font-style: normal;
  margin-top: 0.42857142857142855rem;
}

.u47dc6 {
  display: flex;
  flex-wrap: wrap;
}


.u4646c {
  margin-right: 0.21428571428571427rem;
}

.ukBgk9n {
  margin-right: 1.4285714285714286rem;
  color: #1a2332;
  font-size: 1.1428571428571428rem;
  text-align: left;
  line-height: 0.8571428571428571rem;
  font-style: normal;
  margin-bottom: 2px;
}

.ufd6a8 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.4285714285714286rem;
  height: 1.4285714285714286rem;
  border-bottom-left-radius: 100rem;
  border-top-left-radius: 100rem;
  border-top-right-radius: 100rem;
  border-bottom-right-radius: 100rem;
  margin-left: 0.5rem;
  background: #ffffff;
}

.u47dc6 .active {
  border: 0.07142857142857142rem solid #1290c9;
}

.u47dc6 .active {
  border: 0.07142857142857142rem solid #1290c9;
}

.u807e8 .active {
  color: rgba(18, 144, 201, 1);
}

.u606de .active {
  color: rgba(18, 144, 201, 1);
  fill: #1290c9;
}

#gd5a26 {
  background: #ffffff;
padding-right: 20px;
}

#c2da93 {
  margin-left: 1.28rem !important;
}

/* .ue56a2,#cb14a2{
  margin-top: 0.14285714285714285rem;
} */


.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #1290c9;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #1290c9;
  border-color: #1290c9;
}

.btnbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.uKD8C77,
.conten {
  font-size: 1.2857143rem ;
  /* overflow: hidden; */
}
.tollbar-con-filter {
  display: flex;
  align-items: center;
  height: 34px;
}
.tollbar-con-filter-icon {
  width: 20px;
  height: 15px;
  margin-right: 20px;
  cursor: pointer;
}
.tollbar-con-filter-btn {
  width: 120px;
  height: 36px;
  padding: 0;
  min-height: 36px !important;
  border-radius: 20px !important;
}
.usRlj2QRisk{
   background: #8E86DD !important
}
.tollbar-con-filter-btn {
  background: #1290C9;
}
 .tollbar-con-filter-btn.is-disabled {
  background: #eeeeee !important;
}
.tollbar-con-filter-btn >>> span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #ffffff;
}
.tollbar-con-filter-btn >>> i {
  margin-right: 6px;
  font-size: 12px;
}
 .tollbar-con-filter-btn.is-disabled >>> span {
  color: #999999;
}
/*cssStart*/

/*cssEnd*/
</style>